export const buildError = (action, message, error, throwError = true) => {
    const endMessage = `with error message: ${error.message}`
    const errorMessage = `${action} ${message} ${endMessage}`
    
    if (throwError) {
        throw new Error(errorMessage)
    } else {
        console.log(errorMessage)
    }
}
